import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import QuoteForm from "../../components/QuoteForm";
import QuoteOutput from "../../components/QuoteOutput";
import { partner } from "../../types";
import Header from "./components/Header";

const DefaultPartner = ({ partner }) => {
  const navigate = useNavigate();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loanAmount, setLoanAmount] = useState(0);
  const [results, setResults] = useState([]);

  const handleResults = (newResult, loanAmount) => {
    setResults(newResult);
    setIsSubmitted(true);
    setLoanAmount(loanAmount);
    navigate("#result");
  };

  return (
    <div className="sqz-wrapper">
      <Header
        logoFileName={partner.logoFileName}
        partnerWebsiteUrl={partner.partnerWebsiteUrl}
        partnerName={partner.partnerName}
      />
      <React.Fragment>
        {isSubmitted ? (
          <QuoteOutput loanAmount={loanAmount} products={results} />
        ) : (
          <QuoteForm
            handleResults={handleResults}
            colorScheme={partner.colorScheme}
          />
        )}
      </React.Fragment>
    </div>
  );
};

DefaultPartner.propTypes = {
  partner,
};

export default DefaultPartner;
